import "./event_list_module.module.scss"; import "./event_list_module.module.scss.json"

